<template>
  <div class="menu-wrapper">
    <template v-for="item in menu">
      <!-- 最后一级菜单 -->
      <el-menu-item v-if="!item.hasChildren" :key="item.id" :index="item.path" class="menu-item">
        <i :class="item.icon"></i>
        <el-tooltip
          slot="title"
          class="item"
          effect="dark"
          :content="item.name"
          placement="right-start"
        >
          <span>{{ item.name }}</span>
        </el-tooltip>
      </el-menu-item>

      <!-- 此菜单下还有子菜单 -->
      <el-submenu v-if="item.hasChildren" :key="item.id" :index="item.id + ''">
        <template slot="title">
          <i :class="item.icon"></i>
          <el-tooltip
            slot="title"
            class="item"
            effect="dark"
            :content="item.name"
            placement="right-start"
          >
            <span>{{ item.name }}</span>
          </el-tooltip>
        </template>
        <!-- 递归 -->
        <sidebar-item :menu="item.children" :parent="parent ? parent  + item.path : item.path" />
      </el-submenu>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: ['menu', 'parent'],
  data() {
    return {}
  },
}
</script>

<style></style>